







































































import Vue from "vue";
import { Component, ModelSync, PropSync, Watch } from "vue-property-decorator";
import EventEditorSlotGroupPlayerSlot from "@/components/arma/events/editor/EventEditorSlotGroupPlayerSlot.vue";
import PlayerSlot from "@/classes/PlayerSlot";
import SlotGroup from "@/classes/SlotGroup";

@Component({
  components: { EventEditorSlotGroupPlayerSlot },
})
export default class EventEditorSlotGroup extends Vue {
  @ModelSync("slotGroupValue", "input")
  public readonly slotGroup!: SlotGroup;

  public validationRules = {
    SlotGroupNameRules: [
      (value: string) => {
        if (value) { return true; }

        return "Squad name is required.";
      },
      (value: string) => {
        if (value.length <= 50) { return true; }

        return "Squad name must be 50 characters or less.";
      },
    ],
    SlotGroupDescriptionRules: [
      (value: string) => {
        if (value) { return true; }

        return "Squad description is required.";
      },
      (value: string) => {
        if (value.length <= 200) { return true; }

        return "Squad description must be 200 characters or less.";
      },
    ],
  };

  @PropSync("renderTrashButtonValue")
  public readonly renderTrashButton!: boolean;

  @PropSync("renderPlusButtonValue")
  public readonly renderPlusButton!: boolean;

  @Watch("slotGroup.name")
  public onPropertyChanged(newName: string) {
    this.$emit("renameSlotGroup", newName, this.slotGroup);
  }

  /**
   * Adds a new default PlayerSlotItem to the collection.
   */
  public addNewSlotToSlotGroup() {
    this.slotGroup.playerSlots.push(new PlayerSlot());
  }

  /**
   * Emits an event to let the parent component know that a new slot group should be added.
   */
  public addNewSlotGroup() {
    this.$emit("addNewSlotGroup");
  }

  /**
   * Removes a given PlayerSlotItem from the PlayerSlotCollection.
   *
   * @param index
   */
  public removeSlotFromSlotGroup(index: number) {
    this.slotGroup.playerSlots.splice(index, 1);
  }

  public copySlot(index: number) {
    const previous = this.slotGroup.playerSlots[index];

    this.slotGroup.playerSlots.push(
      new PlayerSlot(previous.name, previous.description, previous.leader, previous.lottery, previous.tags)
    );
  }

  public mounted() {
    if (this.slotGroup.playerSlots.length === 0) {
      this.addNewSlotToSlotGroup();
    }
  }
}
